import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
export function UseCaseRealEstatePage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-958">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-959">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-960">
          <div className="aurora-blob bg-[#7B2FFF] w-[600px] h-[600px] top-[-10%] right-[-10%] animate-aurora-1" data-id="element-961"></div>
          <div className="aurora-blob bg-[#00E5FF] w-[800px] h-[800px] bottom-[-20%] left-[-10%] animate-aurora-2" data-id="element-962"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-963">
          <div className="inline-block px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6" data-id="element-964">
            <span className="text-sm font-bold text-gradient uppercase tracking-wider" data-id="element-965">
              {t('useCaseRealEstate.badge')}
            </span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-966">
            {t('useCaseRealEstate.heroTitle')}
            <span className="text-gradient" data-id="element-967">
              {t('useCaseRealEstate.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-968">
            {t('useCaseRealEstate.heroDesc')}
          </p>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(123,47,255,0.3)]" data-id="element-969">
            {t('useCaseRealEstate.bookDemo')}
          </a>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-970">
        <div className="max-w-4xl mx-auto px-6" data-id="element-971">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-972">
            {t('useCaseRealEstate.challengeTitle')}
          </h2>
          <div className="space-y-6" data-id="element-973">
            {[0, 1, 2].map(idx => <div key={idx} className="flex items-center p-8 bg-[#050505] rounded-2xl border border-white/10" data-id="element-974">
                <div className="w-1.5 h-12 rounded-full bg-white/20 mr-6 shrink-0" data-id="element-975"></div>
                <p className="text-xl text-white/80 font-medium" data-id="element-976">
                  {t(`useCaseRealEstate.pain${idx}`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-977">
        <div className="max-w-7xl mx-auto px-6" data-id="element-978">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-979">
            {t('useCaseRealEstate.solutionTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-980">
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 hover:border-white/20 transition-colors" data-id="element-981">
              <h3 className="text-2xl font-bold mb-4 text-gradient" data-id="element-982">
                Trippp Map
              </h3>
              <p className="text-white/60 text-lg leading-relaxed" data-id="element-983">
                {t('useCaseRealEstate.mapDesc')}
              </p>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 hover:border-white/20 transition-colors" data-id="element-984">
              <h3 className="text-2xl font-bold mb-4 text-gradient" data-id="element-985">
                Trippp Spark
              </h3>
              <p className="text-white/60 text-lg leading-relaxed" data-id="element-986">
                {t('useCaseRealEstate.sparkDesc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-987">
        <div className="max-w-5xl mx-auto px-6" data-id="element-988">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-989">
            {t('useCaseRealEstate.impactTitle')}
          </h2>
          <div className="space-y-8" data-id="element-990">
            {[0, 1].map(idx => <div key={idx} className="flex items-stretch p-8 bg-[#050505] rounded-2xl border border-white/5" data-id="element-991">
                <div className="w-1.5 rounded-full bg-gradient-animated mr-8 shrink-0" data-id="element-992"></div>
                <p className="text-xl text-white/80 leading-relaxed italic" data-id="element-993">
                  "{t(`useCaseRealEstate.impact${idx}`)}"
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#050505] border-t border-white/5" data-id="element-994">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-995">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-996"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-997"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-998">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-999">
            {t('useCaseRealEstate.ctaTitle')}
            <span className="text-gradient" data-id="element-1000">
              {t('useCaseRealEstate.ctaHighlight')}
            </span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-1001">
            {t('useCaseRealEstate.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}